import React from 'react';
import { Provider } from 'react-redux';
import configureStore from './configureStore';
export default function StateDecorator({ initialState, children, }) {
    const store = configureStore(initialState);
    return React.createElement(Provider, { store: store }, children);
}
